<div class="flex items-center justify-center px-4 py-2 ">
  <div class="avatar">
    <div class="w-6 flex items-center justify-center rounded-full bg-primary/80 text-base-100">
      <span >
        {{ (me() | async)?.displayName?.at(0) }}
      </span>
    </div>
  </div>
  @if (!collapsed()) {
  <div class="flex grow ml-2 flex-col items-start  p-2" >
    <span class="text-xs text-base-content/90">
      {{ (me() | async)?.displayName }}
    </span>
    <span class="text-xs text-base-content/75"> {{ (me() | async)?.jobTitle }}</span>
  </div>
  }
</div>